import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup, TabContent, TabPane } from "reactstrap";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import OptionM from "../../components/DynmicOption/OptionM";
import OptionC from "../../components/DynmicOption/OptionC";
import NCSCUpdate from "./Update/NCSCUpdate";
import NCSCUpdate1 from "./Update/NCSCUpdate1";
import NCSCUpdate2 from "./Update/NCSCUpdate2";
import NCSCUpdate3 from "./Update/NCSCUpdate3";
import NCSCUpdate4 from "./Update/NCSCUpdate4";
import NCSCUpdateGe from "./Update/NCSCUpdateGe";
import NCSCUpdateTrade from "./Update/NCSCUpdateTrade";
import NCSCUpdate1Physi from "./Update/NCSCUpdate1Physi";
import NCSCUpdate3Main from "./Update/NCSCUpdate3Main";

const NCSCDAView = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Change, setchange] = useState(true);
    const [Gender, setGender] = useState(false)
    const [Caste, setCaste] = useState(false)
    const [vh, setvh] = useState(false)
    const [oh, setoh] = useState(false)
    const [hh, setHH] = useState(false)
    const [cl, setcl] = useState(false)
    const [mr, setmr] = useState(false)
    const [md, setmd] = useState(false)
    const tableRef = useRef(null);
    const [otherss, setotherss] = useState(false)
    const [activeIconTab, setActiveIconTab] = useState("5");
    const toggleIconTab = (icontab) => {
        if (activeIconTab !== icontab) setActiveIconTab(icontab);
    };
    const [open, setIsOpen] = useState(false);
    const [GTotal, setGTotal] = useState(0);
    const [Show, setShow] = useState(false);
    const [Totall, setTotal] = useState([]);
    const [Totall2, setTotal2] = useState([]);
    const [Totall3, setTotal3] = useState([]);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const today = new Date();
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const CalCheck = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Ncsdacal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "Hide") {
                        setShow(true)
                    } else {
                        setShow(false)
                    }
                })


    };
    const Total = async (empId) => {

        const sendData = {
            EmploymentId: Number(empId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/GetNcscDaDetailsTotal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setTotal(data[0])
                })


    };
    const Total2 = async (empId) => {

        const sendData = {
            EmploymentId: Number(empId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/GetNcscDaDetailsTotal2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setTotal2(data[0])
                })


    };
    const Total3 = async (empId) => {

        const sendData = {
            EmploymentId: Number(empId),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/GetNcscDaTradeTotal', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setTotal3(data[0])
                })


    };
    const getdata2 = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Getncsdaparam', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)
                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        setuserData(data)
                        Total(data.employmentId)
                        Total2(data.employmentId)
                        Total3(data.employmentId)
                        getdata2(data.employmentId)
                        CalCheck(data.employmentId)
                    }

                })


    };
    const generate = async () => {
        setloading(false)
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            EmploymentRefId: Number(formData.EmploymentRefId),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/GenerateNcscDa', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "Error") {
                        Swal.fire({
                            title: ' This Month Report is Already Submitted',
                            icon: 'error',

                        })
                    } else {
                        setloading(false)
                        getdata()
                    }
                })
    };
    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)
            Total2(employmentId)
            Total3(employmentId)
            CalCheck(employmentId)
            setchange(!Change)
        }
    }, [GTotal])
    useEffect(() => {
        const search = props.location.search;
        const params = new URLSearchParams(search);
        const foo = params.get('data');
        toggleIconTab(foo);
        setGender(true)
        setloading(true)
        getdata()
    }, [])
    useEffect(() => {
        if (activeIconTab === "5") {
            setGender(true)
        }
        else if (activeIconTab === "6") {
            setCaste(true)
        } else if (activeIconTab === "7") {
            setvh(true)
        } else if (activeIconTab === "8") {
            setHH(true)
        } else if (activeIconTab === "9") {
            setoh(true)
        } else if (activeIconTab === "10") {
            setcl(true)
        } else if (activeIconTab === "11") {
            setmr(true)
        } else if (activeIconTab === "12") {
            setmd(true)
        } else if (activeIconTab === "13") {
            setotherss(true)
        }

        getdata()
    }, [activeIconTab])
    useEffect(() => {
        const search = props.location.search;
        const params = new URLSearchParams(search);
        const foo = params.get('data');
        toggleIconTab(foo);
    }, [window.location.search])
    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })
            } else if (result.isDenied) {
                getdata()

            }
        })



    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',
        })
        getdata()
    };
    const Error = async () => {

        Swal.fire({
            title: 'Data Not Perfect',
            icon: 'error',

        })
        getdata()



    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()
    };

    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>

                        <Button onClick={() => window.location.href = '/Dashboard'} color="dark"><em class="icon ni ni-back-alt"></em> BACK</Button>
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>

                            <h3 style={{ marginBottom: 40 }}>Statements of Physical Progress of NCSC-DAs <DownloadTableExcel
                                filename="NCSC-DAs Report"
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                {Draft ? null : activeIconTab !== "17" ? null : <Button style={{ float: "right" }} color="warning" ><Icon class="icon ni ni-download"></Icon><b style={{ fontSize: 18 }}>Export Excel</b></Button>}
                            </DownloadTableExcel>
                            </h3>

                            {Draft ? <Row className="gy-4">
                                <Col md="6">
                                    <OptionM catid="41" defaultValuemain={formData.dummymonth} onInputChange={onInputChange} namemain="month" mainid="month" />
                                </Col>
                                <Col md="6">
                                    <OptionC catid="42" defaultValuemain={formData.year} onInputChange={onInputChange} namemain="year" mainid="year" />
                                </Col>
                                <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col>
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Year: <label style={{ fontWeight: "normal" }}> {userData.yearId}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>

                                        <Col md="4">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>


                                    </Row>
                                    {Show ? <Row>
                                        <Col md="2" lg="3">
                                            <span className="dot dot-lg sq" style={{ background: "red" }}></span>  <b style={{ fontSize: 18 }}>  Caste total is not accurate</b>
                                        </Col>
                                        <Col md="2" lg="3">
                                            <span className="dot dot-lg sq" style={{ background: "darkorange" }}></span>  <b style={{ fontSize: 18 }}>  Male total is not accurate</b>
                                        </Col>
                                        <Col md="2" lg="3">
                                            <span className="dot dot-lg sq" style={{ background: "purple" }}></span>  <b style={{ fontSize: 18 }}>  Female total is not accurate</b>
                                        </Col>
                                        <Col md="2" lg="3">
                                            <span className="dot dot-lg sq" style={{ background: "darkgreen" }}></span>  <b style={{ fontSize: 18 }}>  Transgender total is not accurate</b>
                                        </Col>

                                    </Row> : null
                                    }
                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>


                                        <TabContent activeTab={activeIconTab}>
                                            <TabPane tabId="5">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    Gender Wise Category
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Total </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>


                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>




                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderTotal3} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderMale4} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderFemale5} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderTransgender6} </td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} Gender={Gender} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId="6">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="5" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    Caste-wise Categorisation
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >SC </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >ST </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >OBC</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Others</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>


                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>




                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteSc7} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteSt8} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteObc9} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteOthers10} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >{Totall.totalCat}</td>
                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} Caste={Caste} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId="7">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    VH
                                                                </th>



                                                            </tr>
                                                            <tr >



                                                            </tr>



                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhmale11} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhfemale12} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhtransgender13} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhTotal}</td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} vh={vh} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="8">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    HH
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> :
                                                                    details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.hhmale14} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.hhfemale15} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.hhtransgender16} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >{Totall.hhTotal}</td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} hh={hh} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="9">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    OH
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.ohmale17} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.ohfemale18} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.ohtransgender19} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >{Totall.ohTotal}</td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} oh={oh} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId="10">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    CL
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> :
                                                                    details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.clmale20} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.clfemale21} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.cltransgender22} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.clTotal}</td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} cl={cl} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="11">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    MR
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mrmale23} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mrfemale24} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mrtransgender25} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >{Totall.mrTotal} </td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} mr={mr} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId="12">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    MD
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdmale26} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdfemale27} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdtransgender28} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdTotal} </td>

                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} md={md} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}


                                                        </tbody>

                                                    </table>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="13">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    Others
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>
                                                            <tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Trangender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Total</td>



                                                            </tr>

                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                details.parametersId === 160 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> : details.parentId === -1 ?
                                                                        <tr scope="row" >



                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.sno}</b>

                                                                            </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                            </td>





                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersMale29} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersFemale30} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersTransgender31} </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersTotal}</td>
                                                                        </tr> :
                                                                        Number(details.sno) < 4 ?
                                                                            <NCSCUpdateGe Change={Change} target={details.target} otherss={otherss} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateGe={NCSCUpdateGe} /> : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="14">
                                                <div className="table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    No. of trainees on roll at the end of the month (Trade-wise)
                                                                </th>
                                                                <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', fontWeight: "bold" }} >
                                                                    {Totall3.genderTotal3}
                                                                </th>



                                                            </tr>
                                                            <tr>



                                                            </tr>


                                                        </thead>
                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>

                                                                details.parentId === -5 ?
                                                                    <NCSCUpdateTrade Change={Change} index={index} target={details.target} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdateTrade={NCSCUpdateTrade} />
                                                                    : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="15">
                                                {activeIconTab === "15" ? <div className="table-responsive">
                                                    <table className="table">


                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                Number(details.sno) >= 5 && Number(details.sno) < 10 ?
                                                                    <NCSCUpdate1Physi Change={Change} target={details.target} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate1Physi={NCSCUpdate1Physi} />
                                                                    : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div> : null}
                                            </TabPane>
                                            <TabPane tabId="16">
                                                {activeIconTab === "16" ? <div className="table-responsive">
                                                    <table className="table">


                                                        <tbody>


                                                            {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                                Number(details.sno) > 9 && Number(details.sno) < 13 ?
                                                                    <NCSCUpdate3Main value={details.value} Change={Change} target={details.target} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate3Main={NCSCUpdate3Main} />
                                                                    : null) : null}


                                                        </tbody>
                                                    </table>
                                                </div> : null}
                                            </TabPane>
                                            <TabPane tabId="17">
                                                {activeIconTab === "17" ? <div className="table-responsive">
                                                    <table className="table" ref={tableRef}>
                                                        <thead>
                                                            <tr >

                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Sr. No

                                                                </th>
                                                                <th rowSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                    Activities
                                                                </th>
                                                                <th colSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    Name of the NCSC-DA

                                                                </th>
                                                                <th colSpan="26" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                    For the month
                                                                </th>


                                                            </tr>
                                                            <tr>

                                                                <td colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Gender Wise Category</td>
                                                                <td colSpan="4" rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Caste Wise Category</td>
                                                                <td colSpan="21" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Disability Wise Category</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >VH</td>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >HH</td>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >OH</td>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >CL</td>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >MR</td>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >MD</td>
                                                                <td colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Others</td>

                                                            </tr><tr>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Total </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >SC </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >ST </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > OBC</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Others </td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Male </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} >Female</td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 150 }} > Transgender</td>

                                                            </tr>

                                                        </thead>

                                                        <tbody>


                                                            {dataactive !== [] ? dataactive.map((details, index) =>

                                                                details.parentId === 0 ?
                                                                    <tr scope="row" style={{ borderBottomColor: 'white' }} >

                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.sno}</b>

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                            <b>  {details.name} <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                        </td>
                                                                        <td colSpan="20" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                        </td>


                                                                    </tr> :
                                                                    details.parentId === -8 ?

                                                                        <tr scope="row" >

                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>



                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>  {details.name} --{">"}</b>

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                <b>   {details.genderTotal3}</b>

                                                                            </td>



                                                                        </tr> :

                                                                        details.parentId === -1 ?
                                                                            <tr scope="row" >



                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                    <b>  {details.sno}</b>

                                                                                </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>

                                                                                    <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                                </td>




                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderTotal3} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderMale4} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderFemale5} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.genderTransgender6} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteSc7} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteSt8} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteObc9} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.casteOthers10} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhmale11} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhfemale12} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.vhtransgender13} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.hhmale14} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.hhfemale15} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.hhtransgender16} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.ohmale17} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.ohfemale18} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.ohtransgender19} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.clmale20} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.clfemale21} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.cltransgender22} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mrmale23} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mrfemale24} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mrtransgender25} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdmale26} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdfemale27} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.mdtransgender28} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersMale29} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersFemale30} </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall.othersTransgender31} </td>
                                                                            </tr>
                                                                            :

                                                                            details.parentId === -6 ?
                                                                                <>
                                                                                    <tr scope="row" >
                                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                                                                            <b>  {details.sno}</b>

                                                                                        </td>    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                                                                                            <b>  {details.name}  <br />{details.target >= 0 ? ("Target(" + details.target + ")") : ""}</b>

                                                                                        </td>
                                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {Totall2.genderTotal3} </td>
                                                                                        <td colSpan="28" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > </td>
                                                                                    </tr>

                                                                                    <tr onClick={() => setIsOpen(!open)} scope="row" >




                                                                                        <td >
                                                                                            <h3> {open ? <Icon name="arrow-up-round" /> : <Icon name="arrow-down-round" />} </h3>
                                                                                            <b>{open ? "Hide Trade" : "Show Trade"}</b>
                                                                                        </td>
                                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                                                                                            <b>  Trade Name</b>

                                                                                        </td>
                                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > No.of trainees on roll <br /><br />{Totall3.genderTotal3}</td>
                                                                                        <td colSpan="28" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}></td>
                                                                                    </tr>

                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {details.parentId === -2 ?
                                                                                        <NCSCUpdate1 Change={Change} target={details.target} sno={details.sno} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate1={NCSCUpdate1} />

                                                                                        : details.parentId === -3 ? <NCSCUpdate2 Change={Change} target={details.target} sno={details.sno} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate2={NCSCUpdate2} /> :
                                                                                            details.parentId === -7 ? <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}><td colSpan="19" style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}></td> <td style={{ textAlign: 'center', border: '1px solid white', padding: 10 }} colSpan="12"></td></tr> :
                                                                                                details.parentId === -5 ?
                                                                                                    <><NCSCUpdate4 Change={Change} index={index} open={open} setGTotal={setGTotal} GTotal={GTotal} sno={details.sno} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate4={NCSCUpdate4} />
                                                                                                    </> :
                                                                                                    details.parentId === -4 ? <NCSCUpdate3 Change={Change} target={details.target} sno={details.sno} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate3={NCSCUpdate3} /> :
                                                                                                        <NCSCUpdate Change={Change} target={details.target} sno={details.sno} setGTotal={setGTotal} GTotal={GTotal} edit={false} name={details.name} parametersId={details.parametersId} employmentId={employmentId} NCSCUpdate={NCSCUpdate} />}
                                                                                </>
                                                            ) : null}


                                                        </tbody>
                                                    </table>

                                                </div> : null}
                                            </TabPane>
                                        </TabContent>
                                        {/*
                                        <div style={{ marginTop: 30 }}>
                                            {Number(activeIconTab) > 5 ? <Button style={{ marginRight: 10 }} onClick={(ev) => {
                                                ev.preventDefault();
                                                toggleIconTab(String(Number(activeIconTab) - 1));
                                                window.scrollTo(0, 0);
                                            }} color="primary"  ><Icon name="chevrons-left" /></Button> : null}

                                            {Number(activeIconTab) < 17 ? <Button onClick={(ev) => {
                                                ev.preventDefault();
                                                toggleIconTab(String(Number(activeIconTab) + 1));
                                                window.scrollTo(0, 0);

                                            }} color="primary" ><Icon name="chevrons-right" /></Button> : null}

                                        </div>*/}






                                    </div>
                                    
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default NCSCDAView;
